import TrackableVideo from "./TrackableVideo"

export default TrackableVideo

